import { createAsyncThunk } from '@reduxjs/toolkit'
import { KYCApi } from '../../api'

export const getKYCFormUrlAction = createAsyncThunk('/kyc/getFormUrl', KYCApi.getFormUrl)
